import './cpac/cpac.base.js';
import './cpac/cpac.accounting.proto.js';
import './cpac/cpac.audit.js';
import './cpac/cpac.autocomplete.proto';
import './cpac/cpac.autofilter';
import './cpac/cpac.caReportGenerator';
import './cpac/cpac.childcare';
import './cpac/cpac.confirm.proto';
import './cpac/cpac.errorMessage.proto';
import './cpac/cpac.event.proto';
import './cpac/cpac.fitness.proto';
import './cpac/cpac.form.proto';
import './cpac/cpac.hot-keys';
import './cpac/cpac.invoices.proto';
import './cpac/cpac.packages';
import './cpac/cpac.payment.proto';
import './cpac/cpac.payroll';
import './cpac/cpac.programPaymentPlan';
import './cpac/cpac.resource.proto';
import './cpac/cpac.schedule.week';
import './cpac/cpac.table.proto';
import './cpac/cpac.tabs';
import './cpac/cpac.tennis.proto';
import './cpac/cpac.user.proto';